<header class="page-header">
    <h1>{{'page.comments.name' | translate | upperFirstLetter }}</h1>
</header>